import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';
import { Product } from '../../../../../../../common/js/static/Product';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';

@Component({
  selector: 'schedule-medical-exam',
  moduleId: module.id,
  templateUrl: './schedule-medical-exam.component.html',
})
export class ScheduleMedicalExamComponent {
  channelInfo: { [key: string]: string };
  isMMDirectPolicy: boolean;

  constructor(private modalService: ModalService, private amorphicService: AmorphicService) {
    const policy = this.amorphicService.controller.customer.application.primaryPolicy;
    this.isMMDirectPolicy = policy.isMMDirectPolicy();
    const channel = this.isMMDirectPolicy ? Product.channels.MMDirect : Product.channels.CAS;
    this.channelInfo = {};
    Object.assign(this.channelInfo, channel);
  }

  closeModal(): void {
    this.modalService.deactivate();
  }
}
